import { graphql } from '../../graphql';

export const getCategories = graphql(`
  query Categories {
    categories {
      id
      name
      pluralName
      slug
      areaUnits
      photosRequired
      areRoomsRequired
      hasRepair
      hasBuildingType
      hasFloor
      hasLandArea
      hasRooms
      children {
        id
        name
        pluralName
        slug
        photosRequired
        areaUnits
        areRoomsRequired
        hasRepair
        hasBuildingType
        hasFloor
        hasLandArea
        hasRooms
      }
    }
  }
`);
